import { NodeViewWrapper, NodeViewContent } from '@tiptap/react';

export const NonEditableTag = () => {
  return (
    <NodeViewWrapper className="react-component-with-content">
      <span className="label" contentEditable={false}>
        React Component
      </span>

      <NodeViewContent className="content" />
    </NodeViewWrapper>
  );
};
